// DOM overlay (Rule 2: rendering displays the simulation; this reads sim ticks but
// never writes back). Lives in apps/client because it's a UI concern.
export class DebugOverlay {
  private readonly el: HTMLElement | null;
  private fps = 0;
  private tick = 0;
  private cursorX = 0;
  private cursorY = 0;

  constructor() {
    this.el = typeof document !== 'undefined' ? document.getElementById('debug') : null;
    // Keep debug telemetry available for local development, but hide it in
    // production/mobile builds where it collides with the real HUD.
    if (!import.meta.env.DEV && this.el !== null) {
      this.el.style.display = 'none';
      return;
    }
    this.render();
  }

  setFps(fps: number): void {
    if (this.fps === fps) return;
    this.fps = fps;
    this.render();
  }

  setTick(tick: number): void {
    if (this.tick === tick) return;
    this.tick = tick;
    this.render();
  }

  setCursor(x: number, y: number): void {
    const rx = Math.round(x);
    const ry = Math.round(y);
    if (rx === this.cursorX && ry === this.cursorY) return;
    this.cursorX = rx;
    this.cursorY = ry;
    this.render();
  }

  private render(): void {
    if (this.el === null) return;
    this.el.textContent =
      `FPS:  ${this.fps}\n` +
      `Tick: ${this.tick}  (50ms / 20Hz)\n` +
      `Cur:  ${this.cursorX}, ${this.cursorY}`;
  }
}
